export const numberOfApperanceOptions = [
    {
        key: '1',
        name: 'One'
    },
    {
        key: '2',
        name: 'Two'
    },
    {
        key: '3',
        name: 'Three'
    },
    {
        key: '4',
        name: 'Four'
    },
    {
        key: '5',
        name: 'Five'
    },
    {
        key: '6',
        name: 'Six'
    },
    {
        key: '7',
        name: 'Seven'
    },
    {
        key: '8',
        name: 'Eight'
    },
    {
        key: '9',
        name: 'Nine'
    },
    {
        key: '10',
        name: 'Ten'
    },
    {
        key: 'multiple',
        name: 'Multiple Times'
    },
];

